import { Form, Input } from "antd";

export const TrimmedInput = (props: any) => {
  const form = Form.useFormInstance();
  return (
    <Input
      {...props}
      onBlur={e => {
        const { value } = e.target;
        form.setFieldsValue({ [props.id]: value?.trim() });
        if (props.onBlur) props.onBlur(e);
      }}
    />
  );
};